const BADGE_COLOR_CLASSES = {
  GREEN: 'bg-green-50 text-green-700 ring-green-600/20', // bg-[#f0fdf4] text-[#15803d] ring-[#16a34a/20]
  RED: 'bg-red-50 text-red-700 ring-red-600/20', // bg-[#fef2f2] text-[#b91c1c] ring-[#dc2626/20]
  GRAY: 'bg-gray-50 text-gray-700 ring-gray-600/20', // bg-[#f9fafb] text-[#374151] ring-[#4b5563/20]
  GOLD: 'bg-yellow text-black ring-yellow/20', // bg-[#ffea7e] text-[#000000] ring-[#ffea7e/20]
  PURPLE: 'bg-purple text-white ring-purple/20', // bg-[#5b7fff] text-[#ffffff] ring-[#5b7fff/20]
  BLUE: 'bg-blue-50 text-blue-700 ring-blue-600/20', // bg-[#eff6ff] text-[#1d4ed8] ring-[#2563eb/20],
  AMBER: 'bg-amber-50 text-amber-700 ring-amber-600/20', // bg-[#fffbeb] text-[#b45309] ring-[#d97706/20]
  BRIGHT_GRAY: 'bg-[#727272]/15 text-[#727272] ring-[#727272]/50',
  BRIGHT_PURPLE: 'bg-[#5b7fff]/15 text-[#5b7fff] ring-[#5b7fff]/50',
  BRIGHT_RED: 'bg-[#ff5964]/15 text-[#ff5964] ring-[#ff5964]/50',
  BRIGHT_GREEN: 'bg-[#56ca00]/15 text-[#56ca00] ring-[#56ca00]/50',
  BRIGHT_GOLD: 'bg-[#ffb400]/15 text-[#ffb400] ring-[#ffb400]/50',
  BRIGHT_BLUE: 'bg-[#16b1ff]/15 text-[#16b1ff] ring-[#16b1ff]/50'
};

export { BADGE_COLOR_CLASSES };
